export const SET_USERS_SUPPLIES_ERROR = 'SET_USERS_SUPPLIES_ERROR';
export const SET_USER_BORROWS_ERROR = 'SET_USER_BORROWS_ERROR';
export const ADD_WALLETS_ERROR = 'ADD_WALLETS_ERROR';
export const ADD_NETWORK_ERROR = 'ADD_NETWORK_ERROR';
export const SET_AGREEMENTS_ERROR = 'SET_AGREEMENTS_ERROR';
